module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout-ucenter', [_c('template', {
    slot: "menu"
  }, [(_vm.user.type == 3) ? _c('el-menu', {
    attrs: {
      "mode": "vertical",
      "router": true,
      "default-active": "1"
    }
  }, [_c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v(" 广告管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/ad/stats"
    }
  }, [_vm._v("广告统计")])], 2), _vm._v(" "), _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-setting"
  }), _vm._v(" 账户管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/account/accountuser"
    }
  }, [_vm._v("客户账单")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/account/soundtooth"
    }
  }, [_vm._v("声牙账单")])], 2)], 1) : _c('el-menu', {
    attrs: {
      "mode": "vertical",
      "router": true,
      "default-active": "1"
    }
  }, [_c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v(" 广告管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/ad/stats"
    }
  }, [_vm._v("广告统计")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/ad/create"
    }
  }, [_vm._v("新建广告")])], 2), _vm._v(" "), _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" 盒子管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/box/list"
    }
  }, [_vm._v("盒子列表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/box/create"
    }
  }, [_vm._v("添加盒子")])], 2), _vm._v(" "), _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-setting"
  }), _vm._v(" 账户管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/account/recharge"
    }
  }, [_vm._v("账户充值")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/account/top-up"
    }
  }, [_vm._v("财务报表")])], 2)], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-435ab392!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/ad-container.vue
// module id = 219
// module chunks = 29